module.exports = __webpack_public_path__ + "static/paso1soluciones-cb3b11962c599757640628e130a189b9.svg";